import styled from 'styled-components';
import { colours } from 'themes/default';

import Icon from 'components/ui/Icons';

export const ScheduleChangedContainer = styled.p`
  color: ${colours.Messaging.WarningOrange};
  font-size: inherit;
`;

export const ScheduleChangedContent = styled.p`
  color: ${colours.Greyscale.White};
  margin: 0;
  padding: 0;
`;

export const ScheduleChangedEmpty = styled.span`
  display: block;

  &::before {
    content: '\\00a0';
  }
`;

export const ScheduleChangedIcon = styled(Icon)`
  display: inline-block;
  height: 1rem;
  margin-left: 0.5rem;
`;

export const ScheduleChangedLoading = styled.span`
  display: block;
  opacity: 0.25;

  &::before {
    content: '...';
  }
`;
